module.exports = new __parcel__URL__("msteamlogo.7a0945dc.svg").toString();